'use client'

import { createContext, useContext, useState } from 'react'
import { useIsFetching, useIsMutating } from '@tanstack/react-query'
import Loading from '@/components/loading-indicator/loading'

const LoaderContext = createContext({
    isLoading: false,
    showLoader: () => { },
    hideLoader: () => { },
})

export function LoaderProvider({ children }) {
    const [manual, setManual] = useState(false)
    const isFetching = useIsFetching()
    const isMutating = useIsMutating()

    const showLoader = () => setManual(true)
    const hideLoader = () => setManual(false)

    // Csak manual loader, NEM automatikus minden fetch-nél
    const isLoading = manual

    return (
        <LoaderContext.Provider value={{ isLoading, showLoader, hideLoader }}>
            {children}
            {isLoading && (
                <Loading />
            )}
        </LoaderContext.Provider>
    )
}

export const useLoader = () => useContext(LoaderContext)
